import { render, staticRenderFns } from "./MRStartups.vue?vue&type=template&id=bf221b9c"
import script from "./MRStartups.vue?vue&type=script&lang=js"
export * from "./MRStartups.vue?vue&type=script&lang=js"
import style0 from "./MRStartups.vue?vue&type=style&index=0&id=bf221b9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports